<div>
  <button mat-button mat-dialog-close style="float: right">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content style="clear: both">
  <app-search-universal-basic (Search)="searchIncidents($event)"></app-search-universal-basic>
  <hr>
  <p>Click the <mat-icon >add</mat-icon> Button to import incident into report.</p>
  <app-view-incidents-tbl [Incidents]="dataSource" (SelectedEvent)="SelectedForReport($event)"></app-view-incidents-tbl>
  <hr>
  <button mat-button mat-dialog-close style="float: right">CLOSE</button>
</div>
